/**
 * @GENERATED from Figma node 693:15901
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const MayvenBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#1139C8"
      d="M17.293 6c-1.304 0-3.218.718-4.07 2.367C12.48 6.877 11.123 6 9.287 6c-1.25 0-3.111.851-3.35 2.74V6.32H2v12.42h3.936v-6.49c0-2.075 1.09-2.606 2.154-2.606.984 0 1.942.691 1.942 2.606v6.49h3.936v-6.064c0-2.181.904-3.032 2.128-3.032 1.01 0 1.968.611 1.968 2.526v6.57H22v-6.676C22 8.26 20.404 6 17.293 6"
    />
  </svg>
);
const ForwardRef = React.forwardRef(MayvenBright);
export { ForwardRef as MayvenBright };
